import React, { useEffect, useState } from 'react';
import { X, BellRing } from 'lucide-react';
interface NotificationBannerProps {
  message: string;
  onClose: () => void;
  autoClose?: boolean;
  duration?: number;
}
export function NotificationBanner({
  message,
  onClose,
  autoClose = true,
  duration = 5000
}: NotificationBannerProps) {
  const [isVisible, setIsVisible] = useState(true);
  useEffect(() => {
    if (autoClose) {
      const timer = setTimeout(() => {
        setIsVisible(false);
        setTimeout(onClose, 300);
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [autoClose, duration, onClose]);
  if (!isVisible) return null;
  return <div className="fixed top-20 left-1/2 transform -translate-x-1/2 z-50 animate-fade-in" data-id="element-1435" data-mp="24969n6solmv3">
      <div className="bg-purple-600 text-white rounded-xl shadow-2xl p-4 flex items-center gap-3 max-w-md" data-id="element-1436" data-mp="1zbxr353mfgtb">
        <BellRing size={24} className="flex-shrink-0" data-id="element-1437" data-mp="2wtoe3w3awly5" />
        <p className="flex-1 font-medium text-sm" data-id="element-1438" data-mp="2rztwcy79ah1p">{message}</p>
        <button onClick={() => {
        setIsVisible(false);
        setTimeout(onClose, 300);
      }} className="p-1 hover:bg-purple-700 rounded transition-colors" data-id="element-1439" data-mp="1c39b07jw64y1">
          <X size={18} data-id="element-1440" data-mp="13b7cwfxap0qx" />
        </button>
      </div>
    </div>;
}